"use client";

/**
 * "Məlumatlar bu gün yeniləndi, 1 noyabr 2026" under a residence's facts
 * (owner, 2026-11-01: korter.az prints prices "as of 13 March 2025"; ours
 * are read from the live listings every time the page is built).
 *
 * `day` is the Baku day the page read its data and `label` that day in
 * words, both from the server. A residence page stays cached for days, so
 * the server writes the date ("... 1 noyabr 2026 tarixində yeniləndi"),
 * which is what a crawler keeps, and the browser alone decides whether
 * that day is today or yesterday for the reader. The server snapshot is
 * null, so hydration matches and the word changes after it.
 */
import { useSyncExternalStore } from "react";
import { RefreshCw } from "lucide-react";
import { useT } from "@/lib/locale-context";
import { bakuDay, freshKind } from "@/lib/residence-top";

const subscribe = () => () => {};
const todayInBaku = () => bakuDay(Date.now());
const onServer = () => null;

export default function FreshLine({ day, label, className = "" }: { day: string; label: string; className?: string }) {
  const t = useT();
  const today = useSyncExternalStore(subscribe, todayInBaku, onServer);
  const kind = today ? freshKind(day, today) : "on";
  const text = t(kind === "today" ? "residence.fresh.today" : kind === "yesterday" ? "residence.fresh.yesterday" : "residence.fresh.on");
  const [before, after = ""] = text.split("{date}");
  return (
    <p className={`flex items-start gap-1.5 text-xs text-gray-500 ${className}`}>
      <RefreshCw className="mt-px h-3.5 w-3.5 shrink-0 text-gray-400" aria-hidden />
      <span>
        {before}
        <time dateTime={day} className="tabular-nums">{label}</time>
        {after}
      </span>
    </p>
  );
}
